export const CURRENT_PAGE = 'CURRENT_PAGE'
export const FLIPBOOK_ZOOM_IN = 'FLIPBOOK_ZOOM_IN'
export const FLIPBOOK_ZOOM_OUT = 'FLIPBOOK_ZOOM_OUT'
export const INIT_PENCIL_CASE = 'Pencil case are iniciated'

export function currentPage(payload) {
  return {
    payload,
    type: CURRENT_PAGE,
  }
}

export function initPencilCase(payload) {
  return {
    payload,
    type: INIT_PENCIL_CASE,
  }
}

export function zoomIn() {
  return {
    payload: {
      zoom: true,
    },
    type: FLIPBOOK_ZOOM_IN,
  }
}

export function zoomOut() {
  return {
    payload: {
      zoom: false,
    },
    type: FLIPBOOK_ZOOM_OUT,
  }
}
